 <div class="SCR-all-msg-pop-area">
   <button class="pop-cls-btn" mat-dialog-close>
      <img src="assets/img/filter-close-icon.png" class="cls-icn" />
   </button>
   <div class="SCR-icn-area" [ngClass]="{'hide' : data?.image.length == 0}">
      <img [src]="data?.image" class="SCR-lg-icn" />
   </div>
   <h5 class="SCR-pop-hdng" [ngClass]="{'hide' : data?.message1.length == 0 , 'text-left' : data?.message1 =='Know your test'}">{{data?.message1}}</h5>
   <div class="SCR-pop-text"><p [innerHTML]="data?.message2"> </p></div>
   <div class="" *ngIf="data?.showClose"><button  mat-dialog-close class="btn-link blue-link">Close</button> </div>
 </div>
